const EPSILON = 1; // px tolerance for sub-pixel scroll rounding

export const getScrollIndicators = ({ scrollTop, clientHeight, scrollHeight }) => ({
  showAbove: scrollTop > EPSILON,
  showBelow: scrollTop + clientHeight < scrollHeight - EPSILON
});
